import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseResourceFormComponent, FuncaoService, GlobalService, LoginContabil, TransferenciaEspecie } from 'eddydata-lib';
import { MessageService } from 'primeng/api';
import { TransferenciaEspecieService } from '../service/transferencia-especie.service';
import { EventoContabilEspecieService } from 'contabil-lib';

@Component({
  selector: 'lib-transferencia-especie-form',
  templateUrl: './transferencia-especie-form.component.html'
})
export class TransferenciaEspecieFormComponent extends BaseResourceFormComponent<TransferenciaEspecie, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  @ViewChild('nome') inputField: ElementRef;
  public totalTransferenciaEspecie: number;
  public listaEspecies: { id: string; nome: string; }[];

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private messageService: MessageService,
    protected funcaoService: FuncaoService,
    protected globalService: GlobalService,
    protected tipoService: TransferenciaEspecieService,
    protected eventoEspecieService: EventoContabilEspecieService,
  ) {
    super(new TransferenciaEspecie(), injector, TransferenciaEspecie.converteJson, tipoService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      nome: [null, [Validators.required]],
      evento: [null, [Validators.required]],
      ativo: [true, [Validators.required]],
      padrao: [false, [Validators.required]],
      duodecimo: [false, [Validators.required]],
      retencao: [false, [Validators.required]],
      exige_descendio: [false, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]]
    });
  }

  protected parametrosExtras(): {} {
    return { relations: 'orgao' };
  }

  protected afterLoad() {

  }

  protected afterInit(): void {
    this.eventoEspecieService.filtrar(0, -1, { 'especie$not_in': 'VAR', orderBy: 'nome' }).subscribe(res => {
      this.listaEspecies = res.content;
    });
  }

  protected campoFoco(): ElementRef {
    return this.inputField;
  }

  protected beforeSubmit() {
    try {
      if (this.entidadeForm.get('nome').value === '') {
        throw new Error('Informe o nome!');
      }
      if (this.entidadeForm.get('evento').value === '') {
        throw new Error('Informe o evento contábil para o tipo de transferência!');
      }
      this.entidadeForm.get('orgao').setValue(this.login.orgao);
    } catch (e) {
      this.messageService.add({ severity: 'error', summary: 'Validação', detail: e });
      throw e;
    }
  }

  protected afterSubmit(ent: TransferenciaEspecie) {
    this.loadResource();
    window.scrollTo(0, 0);
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

}
